/* eslint-disable no-nested-ternary */
/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component, Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Spin, Drawer, Icon, Row, Col, Popconfirm, Button, Link, Tooltip, Popover, Modal } from '../../common/UIComponents';
import DetailsConfig from '../Tasks/DetailsConfig'
import { checkForSMP, showFMP } from '../../helpers/billing'
import { withRouter } from 'react-router';
import { isEmpty, ellipseText } from "../../common/Common";
import EditIcon from '../common/EditIcon';
import EyeIcon from '../common/EyeIcon';
import Copyable from '../common/Copyable';
import TypeOfOrder from './TypeOfOrder';
import I18n from '../../common/I18n';
import ViewDetails from '../Tasks/ViewDetails';
import { OrgContext } from '../../context/OrgContext';
import { colorStatusStyle, colorTagToolTip, getContrastColor } from '../dispatches/helpers';
import AppConfig from '../../config/AppConfig';
import { getDispatchColorObject } from './helpers';
import { RebillIcon } from '../../common/CustomIcon';


class CustomerOrderDetailsComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
      currentOrder: this.props.order || {},
      orders: [],
      inProgress: false,
      detailsVisible: false,
      exptionmessage: this.props.exprecord?.exception_message || {},
      orderNo: this.props.order_no || "",
      status:this.props.exprecord?.status,
      toShow: this.props.toShow ? this.props.toShow : "order",
      is_updated: false,
      currentPath: this.props.location.pathname,
      requireRefresh : false,
      isAnyOrderCloned: false,
      charsToLimit: this.props.charsToLimit,
      screenFrom: this.props.screenFrom || ""
    }
  }

  // update path on location change
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({ currentPath: this.props.location.pathname })
    }
    if (this.props.order !== prevProps.order) {
      this.setState({ currentOrder: this.props.order })
    }
    if(this.props.order_no !== prevProps.order_no){
      this.setState({ orderNo : this.props.order_no })
    }
  }

  getOrderDetails = () => {
    this.setState({
      detailsVisible: true,
    })
  }

  setRefreshValue = (value) => {
    this.setState({
      requireRefresh: value
    })
  }

  handleOrderclonedStatus = (isCloned) => {
    this.setState({requireRefresh: isCloned})
  }

  onClose = () => {
    // if(this.state.requireRefresh){
      this.refreshCallback();
    // }
    this.setState({
      detailsVisible: false,
      requireRefresh: false,
    })
    if(this.state.is_updated){
      this.refreshCallback();
    }
    this.props?.forPopOverClose(this.props.order_no)
  }

  handleEdit = () => {
    this.props.editClick()
    this.onClose()
  }

  refreshCallback = () => {
    if( typeof this.props.refreshCallback === 'function'){
      this.props.refreshCallback();
    }
  }


  showReprocessConfirm = () => {
    Modal.confirm({
      title: 'Confirm Reprocessing',
      content: (
        <>
          <Row>
            <h3 style={{ fontWeight: 'bold' }}>
              This is an adjusted order. We are going to reprocess all the orders which underwent adjustments along with this.
            </h3>
          </Row>
          <Row>
            <h4 style={{ paddingTop: '18px', paddingLeft: '50px', fontWeight: '600' }}>
              Do you want to continue?
            </h4>
          </Row>
        </>
      ),
      okText: 'Yes, Proceed',
      cancelText: 'Cancel',
      onOk: () => {
        this.props.applySmp;
      },
      onCancel: () => {
        console.log('Reprocessing canceled');
      },
    });
  };



  updateParentState = (element, value) => {
    this.setState({
      [element]: value,
    })
  } 
  render() {
    const { currentOrder, charsToLimit } = this.state
    const { tab, isAttempted, showEdit = true, dispatchStatusColors = [] } = this.props;
    const dispatchColorObj = getDispatchColorObject(currentOrder);

    const orderNumberElement = 
      isAttempted && isAttempted === "true" ? (
        <span className="textRed">{this.state.orderNo}</span>
      ) : (
        <span>{this.state.orderNo}</span>
      );
  
    const orderNumberContent = this.state.toShow === "order" ? (
      this.state.status === "EXCEPTION" ?  (
        <Popover
          overlayClassName="popoverWidth"
          title="Exception"
          // content={<div style={{ width: '200px' }}>{!isEmpty(this.state.exptionmessage.exception_message) ? (this.state.exptionmessage.exception_message) : ("Reason not available") } </div>}
          content={
            <div style={{ width: '200px' }}>
              {this.state.exptionmessage?.exception_message
                ? this.state.exptionmessage.exception_message
                : 'Reason not available'}
            </div>
          }
      
        >
          <span className="textRed">{orderNumberElement}</span>
        </Popover>
      ) : (
        <span>{orderNumberElement}</span>
      )
    ) : 
      ellipseText(
        this.props.displayedItem,
        charsToLimit,
        dispatchColorObj ? false : true,
        false,
        this.props.showPopupContainer
      );
    return (
      <Fragment>
      
        <Spin spinning={this.state.inProgress} delay={1000}>
          {!isEmpty(this.props.data) ? (
            <Link onClick={this.getOrderDetails}>{this.props.data}</Link>
          ) : (
              this.props.showIcon ?  <EyeIcon styleObj={{...this.props.eyeIconStyle}} handleClick={this.getOrderDetails}/> : this.state.currentPath.includes('/billing') ? (
                <Row type='flex' gutter={8} style={{ ...this.props.style, flexFlow: "row"}} >
                  <Col>
                    <Link className="clickableLink" onClick={this.getOrderDetails}>
                      { this.state.toShow === "order" ?
                          isAttempted && isAttempted === "true" ? 
                            (<span className="textRed">{this.state.orderNo}</span>) 
                              : this.state.orderNo 
                        :
                        ["hawb","mawb"].includes(this.state.toShow) && !isEmpty(this.props.displayedItem) ? 
                          isAttempted && isAttempted === "true" ? 
                            (<span className="textRed">{ellipseText(this.props.displayedItem, charsToLimit, true)}</span>) 
                              : ellipseText(this.props.displayedItem, charsToLimit, true)
                        : ""
                      }
                    </Link>
                  </Col>
                  {(this.props.isRebillOrder || this.props.isGotRebilled) && (
                    <Col>
                      <Tooltip title="Rebilled Order" placement="top">
                        <RebillIcon />
                      </Tooltip>
                    </Col>
                  )}
                  {((this.state.toShow !== "order" &&
                    !isEmpty(this.props.displayedItem)) ||
                    (this.state.toShow === "order" &&
                    !isEmpty(this.state.orderNo))) && (
                    <Col data-testid={`copy-icon-${this.state.orderNo}`}>
                      <Copyable
                        text={
                          this.state.toShow !== "order"
                            ? this.props.displayedItem
                            : (this?.state?.orderNo ? String(this.state.orderNo).replace(/\([^()]*\)/g, "") : "")
                        }
                      />
                      &nbsp;
                    </Col>
                  )}
                  <Col data-testid={`edit-order-icon-${this.state.orderNo}`}>
                  {this.state.toShow === "order" && showEdit ? (
                  <Tooltip title={I18n.t("general.edit")}>
                    <EditIcon handleClick={this.handleEdit} />
                  </Tooltip>
                ) : null}
                    {this.props.showSMP === true && checkForSMP(currentOrder)}
                  </Col>
                  {this.props.showFMPLink && currentOrder.smp_stamp === "true" && currentOrder.is_smp_applied === true && !this.props.isOnHold && <Col>
                        <Button disabled={this.props.isAdjusted} type="primary" icon='check-circle' size="small" className="textBold fontSize12 "
                            style={{marginTop: 1}} onClick={this.props.applyFmp}>Apply&nbsp;
                            {
                            showFMP()
                            }
                        </Button>
                    </Col>
                   }
                  {
                    currentOrder.smp_stamp === "true" && currentOrder.is_smp_applied === false && !this.props.isOnHold && (
                    <Col>
                        <Button
                          data-testid={`apply-smp-${this.state.orderNo}`}
                          type="primary"
                          size="small"
                          className="textBold fontSize12 "
                          style={{ marginTop: 1 }}
                          disabled={this.props.isAdjusted}
                          icon='check-circle'
                          onClick={this.props.applySmp} 
                        >
                          Apply SMP
                        </Button>
                    </Col>
                  )}


                </Row>
              ) : (
                <Row type ='flex' style={{ flexFlow: "unset" }} gutter={4} align="middle">
                  <Col>
                  <Fragment>
                        {
                          ((this.state.toShow == "order") || (!isEmpty(this.props.displayedItem))) ? ( 
                            <Link
                              className="clickableLink"
                              onClick={this.getOrderDetails}
                              style={dispatchColorObj ? colorStatusStyle(dispatchColorObj) : {}}
                            >
                              {dispatchColorObj ? colorTagToolTip(dispatchColorObj, orderNumberContent) : orderNumberContent}
                            </Link>
                          )
                            : null
                        }
                    {/* <Link className='clickableLink' onClick={ this.getOrderDetails }>
                      {this.state.toShow !== "order"
                      ? ellipseText(this.props.displayedItem, 10, true, false, this.props.showPopupContainer)
                      : this.state.orderNo}
                    </Link> */}
                    {this.props.showSMP === true && checkForSMP(currentOrder)}
                  </Fragment>
                  </Col>
                  {this.props.isRebillOrder && (
                    <Col>
                      <Tooltip title="Rebilled Order" placement="top">
                        <RebillIcon />
                      </Tooltip>
                    </Col>
                  )}
                  {((this.state.toShow !== "order" && !isEmpty(this.props.displayedItem)) || (this.state.toShow === "order" && !isEmpty(this.state.orderNo)))  && (<Col>
                      <Copyable text={this.state.toShow !== "order"
                          ? this.props.displayedItem
                          : (this?.state?.orderNo ? String(this.state.orderNo).replace(/\([^()]*\)/g, "") : "")}  //replace any content within parentheses
                      />
                  </Col>)}
                  </Row>
                  )
                  )}
          {this.state.detailsVisible && (
            <Drawer
              // title={
              //   <OrderTitle
              //     order={currentOrder}
              //     showEdit={this.props.showEdit}
              //     editClick={this.handleEdit}
              //   />
              // }
              placement="right"
              closable={false}
              // onClose={this.onClose}
              visible={this.state.detailsVisible}
              width="90%"
              className="orderDrawerScroll"
              bodyStyle={{
                padding: '0px'
              }}
            >
              <div className="order_details">
              {this.props.currentUIVersion() === "v2" ?
                <ViewDetails
                order_id={currentOrder.id}
                key={currentOrder.id}
                editClick={() => this.handleEdit(currentOrder.id)}
                closable={false}
                onClose={this.onClose}
                showEdit={false}
                // tab={tab}
                // updateParentState={this.updateParentState}
                // showCloneButton={this.props.showCloneButton}
                // handleOrderclonedStatus={this.handleOrderclonedStatus}
                fromIndividualScreen={false}
                currentRoute={this.props.currentRoute || null}
                callFrom={this.props.callFrom || ""}
                handleSuccess={this.props.handleSuccess || null}
                screenFrom={this.state.screenFrom}
                // onUnmount={this.props.onUnmount}
                onUnmount={(orderNumbers,isApproved) => {
                  // Close only this drawer
                  this.setState({ detailsVisible: false });

                  // Call parent prop if provided
                  if (this.props.onUnmount) this.props.onUnmount(orderNumbers, isApproved);
                }}
              />
               :
                <DetailsConfig
                  order_id={currentOrder.id}
                  key={currentOrder.id}
                  editClick={this.handleEdit}
                  onClose={this.onClose}
                  showEdit={this.props.showEdit}
                  tab={tab}
                  updateParentState={this.updateParentState}
                  showCloneButton={this.props.showCloneButton}
                  handleOrderclonedStatus={ this.handleOrderclonedStatus }
                  setRefreshValue={this.setRefreshValue}
                />}
              </div>
            </Drawer>
          )}
        </Spin>
      </Fragment>
    )
  }
}
CustomerOrderDetailsComponent.propTypes = {
  order: PropTypes.shape().isRequired,
  reqFrom: PropTypes.string,
  showCloneButton : PropTypes.bool,
  showPopupContainer : PropTypes.bool,
  forPopOverClose: PropTypes.func,
  charsToLimit:  PropTypes.string,
  eyeIconStyle: PropTypes.shape().isRequired,
  isAdjusted: PropTypes.bool, 
  handleSuccess: PropTypes.func,
  onUnmount: PropTypes.func,
  isRebillOrder: PropTypes.bool,
  isGotRebilled: PropTypes.bool
}
CustomerOrderDetailsComponent.defaultProps = {
  reqFrom: '',
  showCloneButton : true,
  showPopupContainer: false,
  eyeIconStyle: {},
  forPopOverClose: () => { },
  charsToLimit: 10,
  isAdjusted: false,
  handleSuccess: null,
  displayedItem: "",
  onUnmount: () => { },
  isRebillOrder: false,
  isGotRebilled: false
}

export const CustomerOrderDetails = withRouter((props) => {
  const { isAirCargo, currentUIVersion  }= useContext(OrgContext);
  return (
    <CustomerOrderDetailsComponent
      isAirCargo={isAirCargo}
      currentUIVersion={currentUIVersion}
      {...props}
    />
  );
}
);
export default CustomerOrderDetails;


